export const PERMISSIONS_CHECK_ENTITY_PERMISSION =
  'PERMISSIONS_CHECK_ENTITY_PERMISSION';
export const NOT_FOUND_BY_ID = 'NOT_FOUND_BY_ID';
export const NO_PERMISSIONS_CODE = `Error: You don't have specific permissions`;
